
<template>
  <div>
    <v-toolbar class="plight" color="#ddecff" height="54" style="z-index: 2">
      <v-toolbar-title @click="goHome()">
        <img :src="logoToolBar" height="50" style="margin-top:6px;"/>
      </v-toolbar-title>
      <v-spacer/>
      <v-fade-transition>
        <v-toolbar-items v-if="loggedIn">
          <v-menu offset-y>
            <template v-slot:activator="{ on }" v-if="!rolCliente && !rolProveedor">
              <v-btn
                text color="primary"
                style="font-size:16px"
                class="proxima-semi"
                v-on="on"
              >
              <v-badge
                color="green"
                :content="pendingMessages.length"
                v-if="pendingMessages.length > 0"
              >
                <v-icon class="mr-1">mdi-bell</v-icon>
              </v-badge>
              <v-icon v-else class="mr-1">mdi-bell</v-icon>
              </v-btn>
            </template>
            <v-list class="v-list" max-width="400">
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in pendingMessages"
                  :key="i"
                >
                  <v-list-item-content @click="irAlMensaje(item)">
                    <v-list-item-title v-text="item.texto"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>



          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text color="primary"
                style="font-size:16px"
                class="proxima-semi"
                v-on="on"
              >
                {{idubapi.descripcion}}
              </v-btn>
            </template>
            <v-list class="v-list">
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, i) in devuelveEntornos()"
                  :key="i"
                >
                  <v-list-item-content @click="cambiarEntorno(item)">
                    <v-list-item-title v-text="item.descripcion"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text color="primary"
                style="font-size:16px"
                class="proxima-semi"
                v-on="on"
              >
                {{usuario.nombre}}
              </v-btn>
            </template>
            <v-list>
              <v-list-item to="perfil">
                <v-list-item-content>
                  <v-list-item-title>
                    {{localization.perfil}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>
              <v-list-item
                @click="clickMenu('cambiarPassword')"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{localization.cambiarPassword}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>
              <v-list-item to="/configuracion" v-if="(idubapi.restriccionesCliente.restringirAccesoConfigPV != 1) && (!rolCliente && !rolProveedor)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{localization.configuracion}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="idubapi.restriccionesCliente.restringirAccesoConfigPV != 1"/>
              <v-list-item @click="clickMenu('idioma')">
                <v-list-item-content>
                  <v-list-item-title>
                    {{localization.idioma}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider/>
              <v-list-item
                @click="clickMenu('logout')"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{localization.logout}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-fade-transition>
    </v-toolbar>
    <PopUpSeleccionarIdioma v-model="openCambiarIdioma" id="openCambiarIdioma" />
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarPopUpCambiarPassword"
        v-model="mostrarPopUpCambiarPassword" id="mostrarPopUpCambiarPassword"
        :cambiado="cambiadoPopUpCambiarPassword"
        @aceptar="mostrarPopUpCambiarPassword = $event"
      >
        <PopUpCambiarPassword
          @cambiado="cambiadoPopUpCambiarPassword = $event"
          @aceptar="cerrarPopUpPassword()"
        />
      </custom-dialog>
    </v-fade-transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PopUpCambiarPassword from '@/components/perfil/PopUpCambiarPassword'
import PopUpSeleccionarIdioma from './incidencias/PopUpSeleccionarIdioma'

export default {
  components: {
    PopUpCambiarPassword,
    PopUpSeleccionarIdioma
  },
  data () {
    return {
      mostrarPopUpCambiarPassword: false,
      cambiadoPopUpCambiarPassword: false,
      openCambiarIdioma: false,
      mensajesPendientes: [
        {
          mensaje: "Ejemplo 1"
        },
        {
          mensaje: "Ejemplo 2"
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      title: 'title',
      miniVariant: 'miniVariant',
      navigationUser: 'navigationUser',
      loggedIn: 'login/loggedIn',
      usuario: 'login/usuario',
      idubapi: 'login/idubapi',
      rolProveedor: 'login/rolProveedor',
      getSubdominioRolProveedor: 'getSubdominioRolProveedor'
    }),
    localization () {
      return this.$t('toolbar')
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    },
    logoToolBar() {
      return (this.idubapi.imagen) ? 'data:image/*;base64,' + this.idubapi.imagen : require('@/assets/images/logo.png')
    },
    pendingMessages () {
      return this.$store.state.incidencias.pendingMessages
    }
  },
  mounted () {
    this.getPendingMessages() 
  },
  methods: {
    ...mapActions({
      toggleMiniVariant: 'toggleMiniVariant',
      logOut: 'login/logOut',
      cambiarRolActivo: 'login/cambiarRolActivo',
      cambiarIdubapi: 'login/cambiarIdubapi',
      getPendingMessages: 'incidencias/getPendingMessages',
    }),
    goHome () {
      this.$router.push({name: 'home'}).catch(err => { console.log(err)})
    },
    clickMenu (tipo) {
      switch (tipo) {
        case 'miPerfil':
          break
        case 'cambiarPassword':
          this.mostrarPopUpCambiarPassword = true
          break
        case 'configuracion':
          break
        case 'idioma':
          this.openCambiarIdioma = true
          break
        case 'logout':
          this.logOut()
          if(this.getSubdominioRolProveedor !== null) {
            this.$router.push({name: 'login', query: { prov: this.getSubdominioRolProveedor }})
          } else {
            this.$router.push({name: 'login'})
          }

          break
      }
    },
    cerrarPopUpPassword () {
      this.mostrarPopUpCambiarPassword = false
      this.cambiadoPopUpCambiarPassword = false
    },
    cambiarEntorno (entorno) {
      localStorage.setItem('idubapi', JSON.stringify(entorno))
      this.cambiarIdubapi()
    },
    cambiarIdiomaPopup () {
      console.log('OPENIDIOMAPOPUP')
    },
    devuelveEntornos() {
      let entornos = []
      return this.usuario.entornos.filter(entorno => {
        if(entornos.includes(entorno.idubapi)) return
        entornos.push(entorno.idubapi)
        if(this.rolCliente && entorno.COD_ROLES.includes('PV_CLIENTE')) {
          return entorno
        } else if (!this.rolCliente) {
          return entorno
        }
      })
    },
    irAlMensaje(item) {
      this.$router.push({ path: `/solicitudes/${item.idSolicitud}?chat=1` })
    }
  }
}
</script>

<style lang="sass" scoped>
.v-toolbar__title
  cursor: pointer

.triangulito
  border-color: transparent
  border-bottom-color: #fff
  border-style: dashed dashed solid
  border-width: 0 8.5px 8.5px
  height: 0px
  width: 0px
  position: absolute
  bottom: -9px
  z-index: 9
</style>


